import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';

import type {
  EstimationWizardState,
  IEstimationsWizardActions,
} from '@/context/estimationWizardContext/model.ts';
import { initWizardState } from '@/context/estimationWizardContext/model.ts';
import { reducer } from '@/context/estimationWizardContext/reducer.ts';
import { useActions } from '@/context/estimationWizardContext/useActions.ts';
import { useMessages } from '@/hooks/messages';
import { NavigationMessages } from '@/pages/estimation/components/estimationNavigation/messages';
import { getEstimationSteps } from '@/pages/estimation/components/estimationNavigation/model';

export interface IEstimationWizardContext {
  state: EstimationWizardState;
  actions: IEstimationsWizardActions;
}

const EstimationWizardContext = createContext<IEstimationWizardContext>(
  {} as IEstimationWizardContext,
);

export const EstimationWizardProvider: FCC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initWizardState);
  const actions = useActions(dispatch);
  const navigationMessages = useMessages(NavigationMessages);

  useEffect(() => {
    actions.setWizardSteps(getEstimationSteps(navigationMessages));
  }, [actions, navigationMessages]);

  const value = useMemo<IEstimationWizardContext>(
    () => ({
      state,
      actions,
    }),
    [state, actions],
  );

  return (
    <EstimationWizardContext.Provider value={value}>{children}</EstimationWizardContext.Provider>
  );
};

export const useEstimationWizard = () => useContext(EstimationWizardContext);
